/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HotToastService } from '@ngneat/hot-toast';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { ProjectsService } from 'app/core/services/project/projects.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import moment from 'moment';
@Component({
  selector: 'app-new-milestone',
  templateUrl: './new-milestone.component.html',
  styleUrls: ['./new-milestone.component.scss']
})
export class NewMilestoneComponent implements OnInit {
  milestoneFormGroup: FormGroup;
  dateFormat: string = 'DD/MM/YYYY';
  projectDetails: any;
  milestoneDetails: any;
  viewMode: boolean = false;
  isSubmitting: boolean = false;
  progressiveInvoiceStatus: boolean = false;
  phases = [];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<NewMilestoneComponent>,
    private formBuilder: FormBuilder,
    private dataCollectorService: DataCollectorService,
    private projectService: ProjectsService,
    private toast: HotToastService,
    public utilityService: UtilityService) { }

  ngOnInit(): void {
    this.viewMode = this.data?.viewMode || false;
    this.projectDetails = this.data.projectDetails;
    this.progressiveInvoiceStatus = this.projectDetails?.progressive_invoicing?.invoice_dates?.some(invoice => invoice.is_invoiced === true);
    this.milestoneDetails = this.data.milestoneDetails;
    const dueDate: any = moment();
    this.dateFormat = this.utilityService.dateFormat;
    this.milestoneFormGroup = this.formBuilder.group({
      phase: [this.milestoneDetails?.phase_uid],
      name: [this.milestoneDetails?.milestone_title || '', [Validators.required]],
      due_date: [moment(this.milestoneDetails?.dueDate  || dueDate, this.dateFormat), [Validators.required]],
      description: [this.milestoneDetails?.milestone_description || ''],
      progressiveInvoiceInclusion: [this.milestoneDetails?.progressive_invoice_uid ? true: false]
    });
    this.getPhases();
  }

  getPhases(): void {
    this.dataCollectorService.getData(this.projectService.projectsUrl + `${this.projectDetails?.project_uid}/phases`).subscribe((response: any) => {
      this.phases = response['data'];
      let index;
      this.phases.forEach((phase,ind) => {
        if(phase.default){
          phase.phase_name = 'Not added to any phase';
          index = ind;
        }
      });
      this.milestoneFormGroup.get('phase').setValue(this.milestoneDetails?.phase_uid || this.phases[index]?.phase_uid);
    });
  }

  createNewMilestone(): void {
    if (this.isSubmitting) {return;};
    this.isSubmitting = true;
    this.milestoneFormGroup.markAllAsTouched();
    if (!this.milestoneFormGroup.invalid) {
      const payload = {
        milestone: {
          'milestone_title': this.milestoneFormGroup.get('name').value,
          'milestone_description': this.milestoneFormGroup.get('description').value,
          'due_date': moment(this.milestoneFormGroup.get('due_date').value).format('YYYY-MM-DD'),
          'phase_uid': this.milestoneFormGroup.get('phase').value || '',
          'add_to_progressive_invoicing':  this.milestoneFormGroup.get('progressiveInvoiceInclusion').value || false
        }
      };
      const loadingToast = this.toast.loading('Craeting new Milestone');
      this.projectService.addMilestone(this.projectDetails?.project_uid, payload).subscribe((response: any) => {
        loadingToast.close();
        this.toast.success(response.message);
        const newMilestone = {phase_uid:this.milestoneFormGroup.get('phase').value, milestone:response.data.milestone};
        this.dialogRef.close({status:true, newMilestone});
        this.isSubmitting = false;
      }, (error: any) => {
        loadingToast.close();
        this.isSubmitting = false;
      });
    }
  }

  updateMilestone(): void {
    if (this.isSubmitting) {return;};
    this.isSubmitting = true;
    this.milestoneFormGroup.markAllAsTouched();
    if (!this.milestoneFormGroup.invalid) {
      const payload = {
        milestone: {
          'milestone_title': this.milestoneFormGroup.get('name').value,
          'milestone_description': this.milestoneFormGroup.get('description').value,
          'due_date':  moment(this.milestoneFormGroup.get('due_date').value).format('YYYY-MM-DD'),
          'phase_uid': this.milestoneFormGroup.get('phase').value || ''
        }
      };
      if(this.milestoneFormGroup.get('progressiveInvoiceInclusion').value){
        payload.milestone['add_to_progressive_invoicing'] = this.milestoneFormGroup.get('progressiveInvoiceInclusion').value;
      }
      const loadingToast = this.toast.loading('Updating Milestone');
      this.projectService.updateMilestone(this.projectDetails?.project_uid, this.milestoneDetails?.milestone_uid, payload).subscribe((response: any) => {
        loadingToast.close();
        this.toast.success(response.message);
        payload['milestone_uid'] = this.milestoneDetails?.milestone_uid;
        payload['data'] = response.data;
        this.dialogRef.close({status:true, payload});
        this.isSubmitting = false;
      }, (error: any) => {
        loadingToast.close();
        this.isSubmitting = false;
      });
    }
  }

}
